import { defineRouteDef, z } from '@/domains/common/api';

export const resetDemoInboxRoute = defineRouteDef({
  method: 'POST',
  path: '/api/email/reset-demo',
  audience: 'user',
  body: z.object({
    employer_id: z.uuid(),
  }),
  output: z.object({
    ok: z.literal(true),
    threads_deleted: z.number(),
    proposed_actions_deleted: z.number(),
    sent_subjects: z.array(z.string()),
  }),
});

export const previewResetDemoInboxRoute = defineRouteDef({
  method: 'GET',
  path: '/api/email/reset-demo/preview',
  audience: 'user',
  query: z.object({
    employer_id: z.uuid(),
  }),
  output: z.object({
    thread_count: z.number(),
    message_count: z.number(),
    sender_email: z.string().nullable(),
  }),
});
